import { ChangePasswordModel } from './../../model/change-password.model';
import { SubmitAction } from './actions';
import { changePassword_Form } from './selectors';
import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../component-base';
import { OnDestroy } from '@angular/core';
import {
  commomState_ElevatedAccess,
  commonState_IsSending,
} from 'src/app/store/common/common.selectors';
import { NgIf, AsyncPipe } from '@angular/common';
import {
  AppToolbarOptionsComponent,
  EntryFieldComponent,
  AppButtonComponent,
} from '@ifaa-components/ui-components';
import { TranslatePipe } from '@ngx-translate/core';
import { NgrxFormsModule } from 'ngrx-forms';
import { AppComponentWrapperComponent } from 'src/app/modules/shared/components/app-component-wrapper/app-component-wrapper.component';
import { AnimateCssDirective } from 'src/app/modules/shared/directives/animatecss.directive';
import { AppButtonDirective } from 'src/app/modules/shared/directives/appbutton.directive';
import { InputScrollDirective } from 'src/app/modules/shared/directives/input-scroll.directive';
import { TextTransformPipe } from 'src/app/modules/shared/pipes/textTransform';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  host: {
    class: 'w-100',
  },
  imports: [
    AppComponentWrapperComponent,
    AppToolbarOptionsComponent,
    TextTransformPipe,
    NgrxFormsModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    AsyncPipe,
    AnimateCssDirective,
    EntryFieldComponent,
    InputScrollDirective,
    TranslatePipe,
    AppButtonComponent,
    AppButtonDirective,
  ],
})
export class ChangePasswordComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  form$ = this.store.pipe(select(changePassword_Form));
  elevatedAccess$ = this.store.pipe(select(commomState_ElevatedAccess));
  isSending$ = this.store.pipe(select(commonState_IsSending));

  elevatedAccess = false;
  constructor(public store: Store<AppState>) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();

    this.elevatedAccess$.subscribe((x) => {
      this.elevatedAccess = x;
    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  onSubmit(data: ChangePasswordModel) {
    if (this.elevatedAccess) return;
    this.dispatch(this.store, SubmitAction({ payload: data }));
  }
}
